/**
 * HubSpot settings. Read from `window.thryvData.hubspot`, which App\Head\ThryvData fills from
 * config/hubspot/ (settings.php: the portal and embed URL; forms.php: every form's name → live GUID
 * and its dataLayer event) — so they have ONE copy, in PHP, and a
 * JS-only caller (a legacy page included) resolves form names exactly as <x-hubspot-form> does.
 *
 * Read per call rather than captured at import, so the values are always the page's current ones.
 */
const data = () => window.thryvData?.hubspot ?? {};

const Config = {
  /** HubSpot's own field names for the built-ins. */
  ownerField: "direct_assignment_rep",
  countryField: "country_code",

  portalId: () => String(data().portal_id ?? ""),
  region: () => data().region || "na1",
  scriptSrc: () => data().script_src || "https://js.hsforms.net/forms/embed/v2.js",
  timeout: () => Number(data().load_timeout_ms) || 10000,
  utmMediumDefault: () => data().utm_medium_default ?? "website",

  /** A form's public definition (no token): config/hubspot/settings.php definition_url, sprintf-style %1$s portal, %2$s form. */
  definitionUrl: (portalId, formId) =>
    String(data().definition_url || "https://forms.hsforms.com/embed/v3/form/%1$s/%2$s/json")
      .replace("%1$s", encodeURIComponent(portalId))
      .replace("%2$s", encodeURIComponent(formId)),

  /** Site country (US | AU | CA | NZ). The same key legacy's HSForm and tracker read. */
  country: () => window.thryvData?.thryv_country || "",

  /** A config name → its GUID; "" when unknown. */
  formId: (name) => (name && data().forms?.[name]) || "",

  /** A GUID → its config name; "" when it is not a named form. */
  formName: (id) => Object.keys(data().forms ?? {}).find((name) => data().forms[name] === id) || "",

  /** The form's legacy dataLayer event definition (config/hubspot/forms.php `event`), or null. */
  event: (name) => (name && data().events?.[name]) || null,
};

export default Config;
